export default __webpack_public_path__ + "images/logo.svg?f1a77ad030da47f2fa7652c69a9e0f79";